import { REGISTER, REGISTER_COMPLETE } from '@/router/route-types';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

import Register from '@/views/Register/Register.vue';
import RegisterComplete from '@/views/Register/RegisterComplete.vue';

export default {
  path: '/register',
  component: DefaultLayout,
  children: [
    {
      path: '',
      name: REGISTER,
      component: Register,
      meta: { auth: false }
    },
    {
      path: 'complete',
      name: REGISTER_COMPLETE,
      component: RegisterComplete,
      meta: { auth: false }
    }
  ],
  meta: { auth: false }
};
